export default "__VITE_ASSET__d9cac768__"